import config from "../config";
import axios from "axios";
import store from "../store";
import auth from "../api/auth";

function catchError(callback, error) {
  console.error(error);
  if (error.response) {
    console.error(error.response.data);
    console.error(error.response.status);
    console.error(error.response.headers);
  }
  if (!error.response) {
    store.dispatch({
      type: "ERROR_API",
      error: error,
    });
    callback(
      {
        module: "client/web",
        success: false,
        api_error: { message: "Server connection error" },
      },
      false
    );
  } else {
    store.dispatch({
      type: "ERROR_API",
      error: error,
    });
    if (error.response.status === 500) {
      console.log("Error 500 - internal server error");
      callback(
        {
          module: "server/web",
          success: false,
          api_error: { message: "Error 500 - internal server error" },
        },
        false
      );
    } else if (error.response.status === 404) {
      console.log("Error 404 - not found");
      callback(
        {
          module: "server/web",
          success: false,
          api_error: { message: "Error 404 - not found" },
        },
        false
      );
    } else {
      if (
        error.response &&
        error.response.data.api_error &&
        error.response.data.api_error.code === 303
      ) {
        auth.logout();
      }
      if (error.response) callback(error.response.data, false);
      else callback({ api_error: { message: error } }, false);
    }
  }
}

function startLoading() {
  store.dispatch({
    type: "LOADING_START",
  });
}

function stopLoading() {
  store.dispatch({
    type: "LOADING_STOP",
  });
}

function reLogin(callback) {
  const state = store.getState();
  if (config.auto_relogin) {
    if (!auth.check_token_timeout() && state.authR.isAuth) {
      console.log("auto relogin");
      auth.login_silent(function (err, response) {
        callback(err, response);
      });
    } else {
      callback(false, true);
    }
  } else {
    callback(false, true);
  }
}

function GET(route, params, callback) {
  startLoading();
  const state = store.getState();
  const config_axios = {
    params: params,
  };
  axios
    .get(
      state.systemR.connection.protocol + state.systemR.connection.host + route,
      config_axios
    )
    .then(function (response) {
      callback(false, response.data);
      stopLoading();
    })
    .catch(function (error) {
      stopLoading();
      catchError(callback, error);
    });
}

function sGET(route, params, callback = null) {
  startLoading();
  const state = store.getState();
  const config_axios = {
    params: params,
  };
  reLogin(function (err, response) {
    if (err) {
      callback(err, false);
    } else {
      if (state.authR.token.token_key && state.authR.user.user_id) {
        config_axios.headers = {
          Authorization: "Bearer " + state.authR.token.token_key,
          AID: state.authR.user.user_id,
        };
        axios
          .get(
            state.systemR.connection.protocol +
              state.systemR.connection.host +
              route,
            config_axios
          )
          .then(function (response) {
            callback(false, response.data);
            stopLoading();
          })
          .catch(function (error) {
            stopLoading();
            catchError(callback, error);
          });
      } else {
        console.log("api/secure/get: NO TOKEN IN REDUX. Caller: " + route);
      }
    }
  });
}

function POST(route, params, callback) {
  startLoading();
  const state = store.getState();
  axios
    .post(
      state.systemR.connection.protocol + state.systemR.connection.host + route,
      params
    )
    .then(function (response) {
      callback(false, response.data);
      stopLoading();
    })
    .catch(function (error) {
      stopLoading();
      catchError(callback, error);
    });
}

function sPOST(route, params, callback) {
  startLoading();
  const state = store.getState();
  const config_axios = {};
  reLogin(function (err, response) {
    if (err) {
      callback(err, false);
    } else {
      if (state.authR.token.token_key && state.authR.user.user_id) {
        config_axios.headers = {
          Authorization: "Bearer " + state.authR.token.token_key,
          AID: state.authR.user.user_id,
        };
        axios
          .post(
            state.systemR.connection.protocol +
              state.systemR.connection.host +
              route,
            params,
            config_axios
          )
          .then(function (response) {
            callback(false, response.data);
            stopLoading();
          })
          .catch(function (error) {
            stopLoading();
            catchError(callback, error);
          });
      } else {
        console.log("api/secure/get: Token is not provided. Caller: " + route);
        stopLoading();
      }
    }
  });
}

const API = {
  GET: GET,
  sPOST: sPOST,
  POST: POST,
  sGET: sGET,
};

export default API;
